
<template>
  <div  class="app-container" ref="appRef">
    <div class="title-container" shadow="never" style="margin-top: 0px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">数据列表</span>
      </div>
      <div class="button-container2">
        <div style="margin-right: 30px;">
          <span class="radio-txt">课时费计算方式:</span>
          <el-radio-group  v-model="radio" @change="onChangeDay">
            <el-radio :label="0">{{redioClassType[0].typeDes}}</el-radio>
            <el-radio :label="1">{{redioClassType[1].typeDes}}</el-radio>
            <el-radio :label="2">{{redioClassType[2].typeDes}}</el-radio>
          </el-radio-group>
        </div>
        <div>
          <el-button type="primary" size="medium" class="operator-btn"
                     icon="el-icon-edit" @click="handleUpdateOneDlg()">修改薪资模板</el-button>
          <el-button type="primary" size="medium" class="operator-btn" style="margin-right: 0px;"
                     icon="el-icon-circle-plus-outline" @click="handleCreateOneDlg()">新增薪资模板</el-button>
        </div>
      </div>
    </div>
    <div class="table-container" shadow="never">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        highlight-current-row
        v-loading="listLoading" border
        @row-click="rowClick">
        <el-table-column prop="name" label="模板名" ></el-table-column>
        <el-table-column prop="lessonTemplateId" label="业务类型" >
          <template slot-scope="scope">
            <el-select v-model="scope.row.lessonTemplateId" placeholder="请选择" disabled>
              <el-option
                v-for="item in lessonTemplateList"
                :key="item.id"
                :label="item.type"
                :value="item.id">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="useCardCommisson" label="耗课提成" >
          <template slot-scope="scope">
            <cmi-step-from :steps="scope.row.arU"></cmi-step-from>
          </template>
        </el-table-column>
        <el-table-column prop="buyCardCommisson" label="开单提成" >
          <template slot-scope="scope">
            <cmi-step-from :steps="scope.row.arB"></cmi-step-from>
          </template>
        </el-table-column>
        <el-table-column prop="classCommisson" label="课时费提成" >
          <template slot-scope="scope">
            <cmi-step-from :steps="scope.row.arC"></cmi-step-from>
          </template>
        </el-table-column>
        <el-table-column prop="inviterCommisson" label="邀请人提成" >
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="删除职位"
      :visible.sync="visibleDlgDelete"
      width="30%"
      center>

      <!--<div class="edit-area">-->
        <!--<el-row style="margin-top: 10px">-->
          <!--<el-col :span="10" ><div style="margin-top: 10px;margin-left: 30px">职位  :</div></el-col>-->
          <!--<el-col :span="14" ><div style="margin-top: 10px;margin-left: 30px">{{deleteParam.position}}</div></el-col>-->
        <!--</el-row>-->
      <!--</div>-->

      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgDelete = false">取消</el-button>
        <el-button type="primary" @click="visibleDlgDelete = false">删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="新增提成模板"
      :visible.sync="visibleDlgAdd"
      width="500px"
      center>
      <el-form label-width="120px" size="small">
        <el-form-item  label="模板名称" >
          <el-input   style="width: 200px" v-model="createParam.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item label="业务类型">
          <el-select v-model="createParam.lessonTemplateId" placeholder="请选择" >
            <el-option
              v-for="item in lessonTemplateList"
              :key="item.id"
              :label="item.type"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="耗课提成">
          <cmi-step ref="refStepUseCard" :step-type="0"  :steps="useCardCommisson">

          </cmi-step>
        </el-form-item>
        <el-form-item label="开单提成">
          <cmi-step ref="refStepBuyCard" :step-type="1" :steps="buyCardCommisson">

          </cmi-step>
        </el-form-item>
        <el-form-item label="课时费提成">
          <cmi-step ref="refStepClass"  :step-type="2"  :steps="classCommisson">
          </cmi-step>
        </el-form-item>
        <el-form-item label="邀请人提成">
          <el-input-number v-model="createParam.inviterCommisson" :precision="2" :min="0"></el-input-number>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleCreateOne">保存</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改提成"
      :visible.sync="visibleDlgUpdate"
      width="500px"
      center>
      <el-form label-width="120px" size="small">
        <el-form-item  label="模板名称" >
          <el-input readonly="true"   style="width: 200px" v-model="updateParam.name" placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="耗课提成">
          <cmi-step :key="refreshKey" ref="refStepUseCardUpdate"  :step-type="0"   :steps="updateParam.arU">

          </cmi-step>
        </el-form-item>
        <el-form-item label="开单提成">
          <cmi-step :key="refreshKey" ref="refStepBuyCardUpdate" :step-type="1"   :steps="updateParam.arB">

          </cmi-step>
        </el-form-item>
        <el-form-item label="课时费提成">
          <cmi-step :key="refreshKey" ref="refStepClassUpdate" :step-type="2"   :steps="updateParam.arC">
          </cmi-step>
        </el-form-item>
        <el-form-item label="邀请人提成">
          <el-input-number v-model="updateParam.inviterCommisson" :precision="2" :min="0"></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgUpdate = false">取消</el-button>
        <el-button type="primary" @click="handleUpdateOne">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
  .radio-txt{
    margin-right: 10px;
    font-size: 16px;
    line-height: 35px;
    text-align: center;
    background-image:-webkit-linear-gradient(left,#0d6fb8, #63b1ff);
    -webkit-background-clip:text;
    -webkit-text-fill-color:transparent;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import {addposition, delWorkerPosition, selectWorkerPosition, updateposition} from "../../../api/storeFront";
  import commonUtils from "../../../utils/commonUtils";
  import messageUtils from "../../../utils/messageUtils";
  import {
    addCommissonTemplate,
    getSalaryClassType,
    saveSalaryClassType,
    selectAllCmi, updateCommissonTemplate
  } from "../../../api/salary/SalaryCommisson";
  import CmiStep from "./CmiStep";
  import CmiStepFrom from "./CmiStepFrom";

  export default {
    components: {CmiStepFrom, CmiStep},
    data() {
      return {
        listLoading: false,
        visibleDlgAdd :false,
        visibleDlgDelete :false,
        visibleDlgUpdate :false,
        //表单结果
        tableData: [
        ],
        createParam:{
          name:'',
          lessonTemplateId:null,
        },

        updateParam:{},
        radio:0,
        redioClassType:[
          {type:0, typeDes:'一对多'},
          {type:1, typeDes:'课程数'},
          {type:2, typeDes:'上课人数'},
        ],

        /**
         * 门店可用的业务类型
         */
        lessonTemplateList:[],

        //耗课提成
        useCardCommisson:[],
        //开单提成
        buyCardCommisson:[],
        //课时费
        classCommisson:[],
        selectRow:"",
        refreshKey:"",
        tableMaxHeight:0,
      }
    },
    created() {
      globaldata.getStoreLessonTemplate(this.getStoreLessonTemplate);
      this.getSalaryClassType();
    },
    beforeMount() {
      this.$nextTick(() => {
        this.tableMaxHeight = this.$refs.appRef.offsetHeight;
      })
    },
    methods: {
      getStoreLessonTemplate(data){
        this.lessonTemplateList = data;
        // let d = {
        //   id:null,
        //   type:"不区分"
        // }
        // this.lessonTemplateList.push(d)
        this.flechList();
      },
      flechList(){
        this.listLoading = true;
        let param = {
          storeFrontId:globaldata.getAdminStore().storeFrontId
        }
        selectAllCmi(param).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.refreshData(data);
        })
      },
      //刷新页面数据
      refreshData(data){
        this.tableData = data;
        for (let i =0;i<this.tableData.length;++i){
          let item = this.tableData[i];
          item.arU = JSON.parse(item.useCardCommisson)
          item.arB = JSON.parse(item.buyCardCommisson)
          item.arC = JSON.parse(item.classCommisson)
        }


      },
      handleDeleteOne(row){
        let param = {
          id:row.id
        }
        delWorkerPosition(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }
          this.flechList();

        })


      },
      doUpdatePosition(t,dlg){

        let positions =[];

        for (let i = 0;i<t.length;++i){
          let power = 0;
          if (!commonUtils.isStringNull(t[i].power)){
            power = t[i].power;
          }
          let p = {
            positions: t[i].position,
            power:power
          }
          positions.push(p)
        }


        let param = {
          id:globaldata.getAdminStore().storeFrontId,
          positons:JSON.stringify(positions)
        }

        updateposition(param).then(response =>
        {
          let date = response.data;
          if (commonUtils.isObjectNull(date)){
            return;
          }
          if (date == true){
            messageUtils.successMsg(this,response.message);
            this.flechList();
          }
          if (dlg == 1) {
            this.visibleDlgAdd = false;
          }
          if (dlg == 2) {
            this.visibleDlgDelete = false;
          }
        })
      },

      rowClick(row, column, event){
        this.selectRow = row;
      },
      checkSelectRow(){
        if (commonUtils.isStringNull(this.selectRow)){
          messageUtils.errorMsg(this,"请选择一条数据")
          return false;
        }
        return true;
      },


      //添加
      handleCreateOneDlg(){
        this.visibleDlgAdd = true;
      },
      handleCreateOne(){
        if (commonUtils.isStringNull(this.createParam.name)){
          messageUtils.errorMsg(this,"请输入模板名")
          return ;
        }
         //不能添加重复的
        for(let i = 0;i< this.tableData.length;++i){
          if (this.createParam.name == this.tableData[i].name) {
            messageUtils.errorMsg(this,"不能添加重复的模板名")
            return ;
          }
        }

        let param = {
          storeFrontId : globaldata.getAdminStore().storeFrontId ,
          lessonTemplateId:this.createParam.lessonTemplateId,
          name:this.createParam.name,
          useCardCommisson:this.$refs['refStepUseCard'].getStepString(),
          buyCardCommisson:this.$refs['refStepBuyCard'].getStepString(),
          classCommisson:this.$refs['refStepClass'].getStepString(),
          inviterCommisson:this.createParam.inviterCommisson,
        };

        addCommissonTemplate(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }
          this.flechList();

        })

      },


      //修改
      handleUpdateOneDlg(){
        if (this.checkSelectRow() == false){
          return;
        }
        this.refreshKey = new Date().getTime()
        this.updateParam = this.selectRow;
        this.visibleDlgUpdate = true;
      },
      handleUpdateOne(){

        let param = {
          id : this.updateParam.id ,
          useCardCommisson:this.$refs['refStepUseCardUpdate'].getStepString(),
          buyCardCommisson:this.$refs['refStepBuyCardUpdate'].getStepString(),
          classCommisson:this.$refs['refStepClassUpdate'].getStepString(),
          inviterCommisson: this.updateParam.inviterCommisson,
        };

        updateCommissonTemplate(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }
          this.visibleDlgUpdate = false;
          this.flechList();
        })
      },
      onChangeDay(val){
        let param = {
          id : globaldata.getAdminStore().storeFrontId ,
          salaryClassType:val,
        };
        saveSalaryClassType(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          if (data == true){
            messageUtils.successMsg(this,response.message)
          } else {
            messageUtils.errorMsg(this,response.message)
          }

        })
      },

      getSalaryClassType(){

        let param = {
          id : globaldata.getAdminStore().storeFrontId ,
        };
        getSalaryClassType(param).then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.radio = data;
        })
      },
    }
  }
</script>






// WEBPACK FOOTER //
// src/views/my-store/salary-commisson/index.vue